/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 表情
 */
export type FindEmsContactFacialExpressionEnum =
  (typeof FindEmsContactFacialExpressionEnum)[keyof typeof FindEmsContactFacialExpressionEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FindEmsContactFacialExpressionEnum = {
  NORMAL: 'NORMAL',
  AGONY: 'AGONY',
  EXCITEMENT: 'EXCITEMENT',
  BLANK: 'BLANK',
  CRYING: 'CRYING',
  VACANT: 'VACANT',
  ANXIOUS: 'ANXIOUS',
  OTHER: 'OTHER',
} as const;
